module.exports = __webpack_public_path__ + "img/Firewheel-bridges.a1fd3877.jpeg";